import { Component } from '@angular/core';

@Component({
  selector: 'app-hero-ferias-charlas-salud',
  standalone: true,
  imports: [],
  templateUrl: '../../hero-empresarial/hero-empresarial.component.html',
  styleUrl: './hero-ferias-charlas-salud.component.css'
})
export class HeroFeriasCharlasSaludComponent {

  name="Ferias y Charlas de Salud";
  description = "Participación en eventos, ferias, charlas, etc. donde se abordan temas de bienestar fisico, mental y nutricional, orientados a mejorar la salud de los empleador.";
  description2 = "";
  routeLogo = "assets/img/enterprise/menu/feriasCharlas.svg";
  routeImage = "assets/img/enterprise/hero/fotoFeriasYCharlas.svg"
}
